module.exports = __webpack_public_path__ + "img/alert_w.49668348.svg";